export const extractNumber = (value?: string | number | null): number | null => {
  if (typeof value === 'number') return value;
  if (value === null || value === undefined) return null;

  const match = String(value).match(/-?\d+(\.\d+)?/);
  if (!match) return null;

  return Number(match[0]);
};
